import { render, staticRenderFns } from "./CapColors.vue?vue&type=template&id=2e94e536&scoped=true&"
import script from "./CapColors.vue?vue&type=script&lang=js&"
export * from "./CapColors.vue?vue&type=script&lang=js&"
import style0 from "./CapColors.vue?vue&type=style&index=0&id=2e94e536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94e536",
  null
  
)

export default component.exports